import { ColumnMapping, HeaderConfig } from './types';

export const createColumnMapping = (headers: any[], headerConfig: HeaderConfig[]): Record<string, ColumnMapping> => {
  const mapping: Record<string, ColumnMapping> = {};
  const mappedKeys = new Set<string>();
  const mappedTypesByIndex = new Map<number, Set<string>>();

  const detectContext = (index: number): string | null => {
    const window = 3;
    const typeCounts: Record<string, number> = {};

    for (let i = Math.max(0, index - window); i < Math.min(headers.length, index + window + 1); i++) {
      if (i === index) continue;
      const types = mappedTypesByIndex.get(i);
      if (types) {
        types.forEach(type => {
          typeCounts[type] = (typeCounts[type] || 0) + 1;
        });
      }
    }

    let maxType: string | null = null;
    let maxCount = 0;
    Object.entries(typeCounts).forEach(([type, count]) => {
      if (count > maxCount) {
        maxCount = count;
        maxType = type;
      }
    });

    return maxType;
  };

  headers.forEach((header, index) => {
    const cleanHeader = String(header).trim();
    if (!cleanHeader) return;

    let configs = headerConfig.filter(c => c.header === cleanHeader);
    if (configs.length === 0) {
      const normalized = cleanHeader.replace(/\s+/g, ' ').trim();
      configs = headerConfig.filter(c => c.header.replace(/\s+/g, ' ').trim() === normalized);
    }
    if (configs.length === 0) {
      configs = headerConfig.filter(c => c.header.toLowerCase().trim() === cleanHeader.toLowerCase().trim());
    }

    if (configs.length === 0) return;

    let selectedConfig = configs[0];
    if (configs.length > 1) {
      const context = detectContext(index);
      const contextConfig = configs.find(c => c.type === context);
      if (contextConfig) {
        selectedConfig = contextConfig;
      } else {
        selectedConfig = configs.find(c => !mappedKeys.has(`${c.key}_${c.type}`)) || configs[0];
      }
    }

    let mapKey = `${selectedConfig.key}_${selectedConfig.type}`;
    if (mappedKeys.has(mapKey)) {
      const unmappedConfig = configs.find(c => !mappedKeys.has(`${c.key}_${c.type}`));
      if (unmappedConfig) {
        selectedConfig = unmappedConfig;
        mapKey = `${selectedConfig.key}_${selectedConfig.type}`;
      }
    }

    if (!mappedKeys.has(mapKey)) {
      mappedKeys.add(mapKey);
      const types = mappedTypesByIndex.get(index) || new Set();
      types.add(selectedConfig.type);
      mappedTypesByIndex.set(index, types);
      mapping[`${cleanHeader}_${index}`] = {
        key: selectedConfig.key,
        index,
        type: selectedConfig.type,
        header: cleanHeader
      };
    }
  });

  return mapping;
};
